import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

// #2980b9
// #eb4d4b
// #130f40
// #535c68
// #2ECC71
// #34495E
// #E67E22
// #D35400
// #C0392B
// #16A085
// #1ABC9C

export default new Vuetify({
    theme: {
        dark: false,
        themes: {
            light: {
                // primary: '#4cbfa6',
                primary: '#214F79', // was so far'#004E7C',
                // secondary: '#301008',
                secondary: '#591COB',
                accent: '#B73225',
                // accent: '#482673',
                error: '#b71c1c',
            },
            dark: {
                primary: '#949ca2', // #455A64  #383838
                secondary: '#bbbbbb',
                accent: '#8c9eff',
                error: '#fc6262',
                success: '#591COB',
            }
        },
    },
});
